import { Component, OnInit, OnDestroy } from '@angular/core';
import { ComplaintService } from '@fuse/services/complaint/complaint.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ComplaintFormDialogComponent } from './complaint-form/complaint-form.component';

@Component({
    selector: 'complaint-management',
    templateUrl: './complaint-management.component.html',
    styleUrls: ['./complaint-management.component.scss'],
    animations: fuseAnimations
})

export class ComplaintManagementComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;

    dialogRef: any;
    searchInput: FormControl;
    lang = 'sr';

    constructor(
        private _complaintService: ComplaintService,
        private _translate: TranslateService,
        private _matDialog: MatDialog,
        private _translationLoader: FuseTranslationLoaderService,
    ) {
        this._unsubscribeAll = new Subject();
        this.searchInput = new FormControl('');
    }

    getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '27');
                console.log(this.lang);
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    newComplaint(): void {
        console.log('Add complaint');

        this.dialogRef = this._matDialog.open(ComplaintFormDialogComponent, {
            panelClass: 'complaint-form-dialog',
            data: {
                action: 'new',
            }
        });

        this.dialogRef.afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                // do nothing
            });
    }

    ngOnInit(): void {
        // this._complaintService.getAllNotifications().subscribe((data) => {
        //     console.log(data);
        // });
        this.getTranslations();
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
